export const PrimaryColor = "#83B4D3";
export const SecondaryColor = "#138390";
export const DarkColor = "#272d2dff";
export const GreyColor = "#C8D3D5";
export const LightColor = "#FCFAFA";